.root {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
  background: var(--backdrop-background);
}

.visible {
  opacity: 1;
  transition: opacity 250ms;
}

.in {
  opacity: 0;
  transition: opacity 0ms;
}

.hidden {
  opacity: 0;
  transition: opacity 250ms;
}

.exitDone {
  display: none;
}
